<template>
  <div>
    <breadcrumb :crumbs="crumbs"></breadcrumb>
    <flash-message></flash-message>
    <div>
      <authorized-link tag="create_user">
        <router-link :to="{ name: 'new_user' }" class="ls-btn-primary ls-no-margin ls-float-right">{{ $t('access_users.main.buttons.new') }}</router-link>
      </authorized-link>

      <br clear="all">
      <div>
        <table class="ls-table ls-table-striped" v-if="accessUsers && accessUsers.length">
          <thead>
            <tr>
              <th>{{ $t('access_users.attributes.name') }}</th>
              <th>{{ $t('access_users.attributes.email') }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user, index) in accessUsers">
              <td>{{ user.name }}</td>
              <td>{{ user.email }}</td>
              <td>
                <div class="ls-float-right">
                  <authorized-link tag="destroy_user" class="ls-float-right">
                    <button v-if="currentUser.id != user.id" class="ls-btn-danger" @click="deleteUser(user, index)">Deletar</button>
                  </authorized-link>
                  <authorized-link class="ls-float-right" tag="update_user">
                    <div class="ls-float-right">
                      <router-link slot="button" :to="{ name: 'edit_user', params: { id: user.id }}" class="ls-btn">{{ $t('application.button.edit') }}</router-link>
                    </div>
                  </authorized-link>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else role="alert">
          <empty-list></empty-list>
        </div>
        <pagination :updater="getAccessUsers"></pagination>
        <modal-destroy v-model="destroyObject"></modal-destroy>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'
  import ModalDestroy from './components/ModalDestroy'
  import Pagination from 'src/app/components/shareds/pagination/Pagination'
  import Dropdown from 'src/app/components/shareds/dropdown/Dropdown'
  import Regroup from 'src/app/components/shareds/regroup/Regroup'
  import EmptyList from 'src/app/components/shareds/empty-list/EmptyList'
  import scroll from 'src/utils/scroll'

  export default {
    name: 'IndexAccessUsers',
    components: {
      Breadcrumb,
      Pagination,
      Dropdown,
      Regroup,
      ModalDestroy,
      EmptyList
    },
    data () {
      return {
        destroyObject: { show: false },
        index: '',
        crumbs: {
          'ico': 'ls-ico-docs',
          'section': this.$t('access_users.main.title'),
          'paths': {
            0: {
              'title': this.$t('access_users.main.title'),
              'path': ''
            }
          }
        }
      }
    },
    mounted () {
      this.getAccessUsers()
    },
    computed: {
      ...mapGetters(['accessUsers', 'pagination', 'currentUser'])
    },
    methods: {
      ...mapActions(['loadAccessUsers', 'destroyAccessUser']),
      ...mapMutations(['setPageData', 'setAccessUser']),
      getAccessUsers () {
        this.$loader.show()
        this.loadAccessUsers().then(this.afterLoad)
      },
      deleteUser (user, index) {
        this.setAccessUser(user)
        this.destroyObject.index = index
        this.destroyObject.show = true
        this.destroyObject.callback = scroll.scrollToFlash
      },
      afterLoad () {
        this.$loader.hide()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Main.vue?bd6a6f64